<div class="breadcrumbGlobal">
  <a [routerLink]="['/mydashboard']">
      <mat-icon>home</mat-icon>
  </a>
  <mat-icon>chevron_right</mat-icon>
  <span translate>COMMONS.VERTICAL_SOLUTIONS_SECTION</span>
</div>

<tb-header specificTitle="COMMONS.VERTICAL_SOLUTIONS_SECTION"></tb-header>
<div class="contentGlobal">

  <div style="display: flex; justify-content: center; flex-wrap: wrap">
    <div>
      <ms-vertical-solution-report-card></ms-vertical-solution-report-card>
      </div>
    <div>
  <ms-vertical-solution-crypt-sales-modules-card></ms-vertical-solution-crypt-sales-modules-card>
  </div>

  <div>
  <ms-vertical-solution-serial-numbers-card></ms-vertical-solution-serial-numbers-card>
</div>

<div><ms-vertical-solution-key-card></ms-vertical-solution-key-card></div>
</div>
